<template>
    <div class="tooltip-shift">
        <b>{{ template.code }}
            <template v-if="shifts[stampShift.shiftId].rosterId !== rosterId">
                ({{ roster?.label ?? 'Vervallen rooster' }})
            </template>
        </b>:
        {{ template.legend }}
        <div class="tooltip-specifications">
            <div v-for="(specification, templateIndex) in template.specifications" :key="templateIndex">
                {{ specification.begin }} - {{ specification.end }}
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import {RosterSelectOption} from '@/types/types';
    import {PersonalStampShift, Template, Shift} from '@cquential/api';

    @Component
    export default class StampTooltipShift extends Vue {
        @Prop({required: true}) public stampShift!: PersonalStampShift;
        @Prop({required: true}) public template!: Template;
        @Prop({required: true}) public shifts!: Record<number, Shift>;
        @Prop({required: true}) public rosters!: RosterSelectOption[];
        @Prop({type: Number, required: true}) public rosterId!: number;

        public get roster(): RosterSelectOption | undefined {
            return this.rosters.find((rosterOption: RosterSelectOption): boolean => rosterOption.data.id === this.shifts[this.stampShift.shiftId].rosterId);
        }
    }
</script>

<style lang="scss" scoped>
    .tooltip-shift {
        margin-bottom: 8px;
    }

    .tooltip-specifications {
        padding-left: 3px;
        border-left: 2px solid #ccc;
        margin-left: 3px;
    }
</style>
